import React from 'react';
import { components } from 'react-select';
import SVGIcon from '../../containers/SVGicon';

export default function DropdownIndicator(props) {
    return (
        <>
            <components.DropdownIndicator {...props}>
                <SVGIcon name='dropdown' width='9' height='6' />
            </components.DropdownIndicator>
        </>
    );
}
